'use strict';

exports.__esModule = true;
exports.default = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _draftJsAndroidFix = require('draft-js-android-fix');

var _IconButton = require('material-ui/IconButton');

var _IconButton2 = _interopRequireDefault(_IconButton);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var ToggleBlockType = function (_Component) {
  _inherits(ToggleBlockType, _Component);

  function ToggleBlockType() {
    var _temp, _this, _ret;

    _classCallCheck(this, ToggleBlockType);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.toggleBlockType = function () {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          editorState = _this$props.editorState,
          blockType = _this$props.blockType;

      var newState = _draftJsAndroidFix.RichUtils.toggleBlockType(editorState, blockType);

      if (newState) {
        onChange(newState);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  ToggleBlockType.prototype.getSelectionEntity = function getSelectionEntity(editorState) {
    var entity = void 0;
    var selection = editorState.getSelection();
    var start = selection.getStartOffset();
    var end = selection.getEndOffset();

    if (start === end && start === 0) {
      end = 1;
    } else if (start === end) {
      start -= 1;
    }

    var block = this.getSelectedBlock(editorState);

    for (var i = start; i < end; i += 1) {
      var currentEntity = block.getEntityAt(i);

      if (!currentEntity) {
        entity = undefined;
        break;
      }

      if (i === start) {
        entity = currentEntity;
      } else if (entity !== currentEntity) {
        entity = undefined;
        break;
      }
    }

    return entity;
  };

  ToggleBlockType.prototype.getEntityRange = function getEntityRange(editorState, entityKey) {
    var block = this.getSelectedBlock(editorState);
    var entityRange = void 0;
    block.findEntityRanges(function (value) {
      return value.get('entity') === entityKey;
    }, function (start, end) {
      entityRange = {
        start: start,
        end: end,
        text: block.get('text').slice(start, end)
      };
    });
    return entityRange;
  };

  ToggleBlockType.prototype.getSelectedBlocksList = function getSelectedBlocksList(editorState) {
    return this.getSelectedBlocksMap(editorState).toList();
  };
  /**
   * Function returns the first selected block.
   */


  ToggleBlockType.prototype.getSelectedBlock = function getSelectedBlock(editorState) {
    if (editorState) {
      return this.getSelectedBlocksList(editorState).get(0);
    }

    return undefined;
  };

  ToggleBlockType.prototype.getSelectedBlocksMap = function getSelectedBlocksMap(editorState) {
    var selectionState = editorState.getSelection();
    var contentState = editorState.getCurrentContent();
    var startKey = selectionState.getStartKey();
    var endKey = selectionState.getEndKey();
    var blockMap = contentState.getBlockMap();
    return blockMap.toSeq().skipUntil(function (_, k) {
      return k === startKey;
    }).takeUntil(function (_, k) {
      return k === endKey;
    }).concat([[endKey, blockMap.get(endKey)]]);
  };

  ToggleBlockType.prototype.renderIcon = function renderIcon() {
    var Icon = this.props.icon;
    return _react2.default.createElement(Icon, null);
  };

  ToggleBlockType.prototype.isDisabled = function isDisabled() {
    var disabled = this.props.disabled;
    return disabled || false;
  };

  ToggleBlockType.prototype.isTextSelected = function isTextSelected() {
    var editorState = this.props.editorState;
    var selectionState = editorState.getSelection();
    var textSelected = selectionState && selectionState.getEndOffset() - selectionState.getStartOffset() !== 0;
    return textSelected;
  };

  ToggleBlockType.prototype.getSelectionText = function getSelectionText(editorState) {
    var selectedText = "";
    var currentSelection = editorState.getSelection();
    var start = currentSelection.getAnchorOffset();
    var end = currentSelection.getFocusOffset();
    var selectedBlocks = this.getSelectedBlocksList(editorState);

    if (selectedBlocks.size > 0) {
      if (currentSelection.getIsBackward()) {
        var temp = start;
        start = end;
        end = temp;
      }

      for (var i = 0; i < selectedBlocks.size; i += 1) {
        var blockStart = i === 0 ? start : 0;
        var blockEnd = i === selectedBlocks.size - 1 ? end : selectedBlocks.get(i).getText().length;
        selectedText += selectedBlocks.get(i).getText().slice(blockStart, blockEnd);
      }
    }

    return selectedText;
  };

  ToggleBlockType.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        editorState = _props.editorState,
        onChange = _props.onChange,
        blockType = _props.blockType,
        icon = _props.icon,
        disabled = _props.disabled,
        other = _objectWithoutProperties(_props, ['editorState', 'onChange', 'blockType', 'icon', 'disabled']);

    return _react2.default.createElement(_IconButton2.default, _extends({
      onClick: function onClick() {
        return _this2.toggleBlockType();
      },
      disabled: this.isDisabled()
    }, other), this.renderIcon());
  };

  return ToggleBlockType;
}(_react.Component);

exports.default = ToggleBlockType;
ToggleBlockType.propTypes = process.env.NODE_ENV !== "production" ? {
  onChange: _propTypes2.default.func.isRequired,
  editorState: _propTypes2.default.object.isRequired,
  blockType: _propTypes2.default.string.isRequired,
  icon: _propTypes2.default.func.isRequired
} : {};
module.exports = exports['default'];